/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ROUTES } from "@nf/constants";
import { useCallback, useEffect } from "react";
import { ActionsHandler } from "components/ActionsHandler";
import { PaymentDetailType } from "components/PaymentDetailType";
import { useBuildLocalizedAbsolutedUrl, useCurrentSubscription } from "hooks";
import { NoSubscriptionsContainer } from "../NoSubscriptionContainer/NoSubscriptionsContainer";
import { ChangePaymentDetailsButton, PaymentDetailsText } from "./components";
import { useCreatePaymentDetails } from "./hooks/useCreatePaymentDetails";
import { useGetPaymentDetails } from "./hooks/useGetPaymentDetails";

import styles from "./SettingsPaymentDetails.module.scss";

export const SettingsPaymentDetails = () => {
  const buildLocalizedAbsoluteUrl = useBuildLocalizedAbsolutedUrl();
  const currentSubscription = useCurrentSubscription();

  const {
    data: currentPaymentDetails,
    error: currentPaymentDetailsError,
    isLoading: isFetchingCurrentPaymentDetails,
    mutate: getPaymentDetails,
  } = useGetPaymentDetails();

  const {
    data: newPaymentDetails,
    isLoading: isCreatingPaymentDetails,
    mutateAsync: createPaymentDetails,
  } = useCreatePaymentDetails();

  const changePaymentDetails = useCallback(() => {
    createPaymentDetails({
      AcceptUrl: buildLocalizedAbsoluteUrl(ROUTES.PAYMENT_UPDATING),
      CancelUrl: buildLocalizedAbsoluteUrl(ROUTES.SETTINGS_PAYMENT_DETAILS),
    }).then((paymentOrder) => {
      if (paymentOrder.CheckoutUrl) {
        window.location.href = paymentOrder.CheckoutUrl;
      }
    });
  }, []);

  useEffect(() => {
    getPaymentDetails();
  }, []);

  return (
    <div>
      <ActionsHandler
        error={
          currentPaymentDetailsError ? currentPaymentDetailsError : undefined
        }
        centeredError
        isLoading={isFetchingCurrentPaymentDetails}
      >
        {currentSubscription ? (
          <>
            <PaymentDetailType subscription={currentSubscription} />
            <div className={styles.paymentDetails}>
              {currentPaymentDetails && (
                <PaymentDetailsText
                  cardType={currentPaymentDetails.CardType}
                  maskedCard={currentPaymentDetails.MaskedCard}
                />
              )}
            </div>
          </>
        ) : (
          <NoSubscriptionsContainer />
        )}
      </ActionsHandler>

      {currentSubscription && !newPaymentDetails && (
        <ChangePaymentDetailsButton
          isLoading={isCreatingPaymentDetails}
          onClick={changePaymentDetails}
        />
      )}
    </div>
  );
};

export default SettingsPaymentDetails;
